/* tslint:disable */
/* eslint-disable */
/**
 * Car Repair Register API
 * Evidence of customers and vehicles for small workshops.
 *
 * The version of the OpenAPI document: 1.2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RepairLogUpdate
 */
export interface RepairLogUpdate {
    /**
     * 
     * @type {string}
     * @memberof RepairLogUpdate
     */
    content: string;
    /**
     * 
     * @type {number}
     * @memberof RepairLogUpdate
     */
    vehicleId: number;
    /**
     * 
     * @type {number}
     * @memberof RepairLogUpdate
     */
    odometer: number | null;
    /**
     * 
     * @type {string}
     * @memberof RepairLogUpdate
     */
    repairDate: string;
}

/**
 * Check if a given object implements the RepairLogUpdate interface.
 */
export function instanceOfRepairLogUpdate(value: object): value is RepairLogUpdate {
    if (!('content' in value) || value['content'] === undefined) return false;
    if (!('vehicleId' in value) || value['vehicleId'] === undefined) return false;
    if (!('odometer' in value) || value['odometer'] === undefined) return false;
    if (!('repairDate' in value) || value['repairDate'] === undefined) return false;
    return true;
}

export function RepairLogUpdateFromJSON(json: any): RepairLogUpdate {
    return RepairLogUpdateFromJSONTyped(json, false);
}

export function RepairLogUpdateFromJSONTyped(json: any, ignoreDiscriminator: boolean): RepairLogUpdate {
    if (json == null) {
        return json;
    }
    return {
        
        'content': json['content'],
        'vehicleId': json['vehicleId'],
        'odometer': json['odometer'],
        'repairDate': json['repairDate'],
    };
}

export function RepairLogUpdateToJSON(json: any): RepairLogUpdate {
    return RepairLogUpdateToJSONTyped(json, false);
}

export function RepairLogUpdateToJSONTyped(value?: RepairLogUpdate | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'content': value['content'],
        'vehicleId': value['vehicleId'],
        'odometer': value['odometer'],
        'repairDate': value['repairDate'],
    };
}

